import Color from '../data/Color';
import ColorBuilder from '../utils/ColorBuilder';
import { Container, getMovieClipByName, MovieClip } from '../utils/utils';

export default class SelectedColorIndicators {
  // ================================================================================================
  // properties
  // ================================================================================================
  private mainImage: MovieClip;

  private secondImage: MovieClip;

  private thirdImage: MovieClip;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(container: Container) {
    this.mainImage = getMovieClipByName(container, 'main_selected_color_indicator');
    this.secondImage = getMovieClipByName(container, 'second_selected_color_indicator');
    this.thirdImage = getMovieClipByName(container, 'third_selected_color_indicator');
  }

  // ----------------------------------------------------------------------------------------------
  set mainColor(value: Color) {
    ColorBuilder.Apply(this.mainImage, value);
  }

  // ----------------------------------------------------------------------------------------------
  set secondColor(value: Color) {
    ColorBuilder.Apply(this.secondImage, value);
  }

  // ----------------------------------------------------------------------------------------------
  set thirdColor(value: Color) {
    ColorBuilder.Apply(this.thirdImage, value);
  }
}
